<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 approve__wrap">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/kinara_logo.svg"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div v-if="checkisLogin"  class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                
           
              <div class="px-8 login-tabs-container">
              <div class="vx-card__title mb-4">
                <div class="alert_messages">


                 <div class="createticket_form" v-if="isEverythingOk">
                  <template v-if="action=='Approve' && true">
                    <form autocomplete="off" v-if="action=='Approve'">
                    
                      <ul>
                    
                      <li v-if="selectedUser && selectedUser.isFirstCustomer"> 
                      <div class="form-group">
                          <label class="form_label">Company Name*</label>
                          <vs-input
                            v-validate="'required|min:3|max:50'"
                            data-vv-as="Company Name"
                            name="Company Name"
                            icon-no-border
                            icon-pack="feather" 
                            v-model="selectedUser.companyDetails.name"
                            
                            class="w-full"
                          />
                          <span class="text-danger text-sm">{{
                            errors.first("Company Name")
                          }}</span>
                          </div>
                      </li>

                        <div class="form-group">
                        <label class="form_label">Preferences</label>
                        <li>
                        <!-- {{selected_settings}}-->
                          <div class="d-flex justify-content-between mt-4">
                          <template  v-for="(item, index) in settings_list">
                        
                              <vs-checkbox :disabled="item._id==2 && (selected_settings.indexOf(1)<=-1)" v-bind:key="index" v-model="item.selected" @change="setPreference($event, item)">{{item.name}}</vs-checkbox>
                          </template>
                              
                          </div>
                        </li> 
                        </div>
                      </ul>
                    </form>
                  </template>
                  <template v-else>
                  <span>Are you sure want to reject  Customer.</span>
                  </template> 


                  <div class="form_actions">
                    <span></span>
                    <button :disabled="disableBtn"  class="close_popup primary_btn" @click="onApprove()">
                      {{action}}
                    </button>
                    
                  </div>
                 </div>
              <!---SUCCESSS MESSAGE-->
                    <template >
                    <template  v-if="successMessage" class="">
                    <figure><img
                        src="@/assets/images/pages/checked.svg"
                        alt="register"
                        class="mx-auto"
                    /></figure>
                    <p >
                        {{msg}}
                    </p>
                    </template>

                    <!--ERROR MESSAGE-->
                    <template v-if="error"  >
                    <figure><img
                        src="@/assets/images/pages/error.svg"
                        alt="register"
                        class="mx-auto"
                    /></figure>
                        <p > {{msg}} </p>
                    </template>
                    </template>  
                   
                </div>  
                </div>

                 <div class="login_btn" v-if="successMessage || error">
                  <router-link to="/login" class="primary_btn"> Login</router-link> 
                </div>
             
                
              </div>
            </div>
            <div v-if="!checkisLogin" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 login-tabs-container">
                

                <login-jwt @detailsGet="getDetails"></login-jwt>
               
              </div>
            </div>

          </div>
        </div>
      </vx-card>
    </div>
    
  </div>
</template>


<script>
import LoginJwt from "@/views/pages/login/LoginJWT.vue";
/*import LoginFirebase from "./LoginFirebase.vue";
import LoginAuth0 from "./LoginAuth0.vue";*/
import _ from "lodash";
export default {
  components: {
   LoginJwt,
   /*  LoginFirebase,
    LoginAuth0,*/
  },
  data() {
    return {
      popupcreateticket: false,
      error: false,
      switch1: true,
      switch2: true,
      switch3: true,
      usersList: [],
      sortKey: {},
      userId: "",
      key: "",
      page: 1,
      perPage: 25,
      totalpages: 0,

      // Cell Renderer Components
      components: {},
      validateEmail:true,
      selected_settings:[],
      settings_list:[],
      selectedUser:null,
      popupApprove:false,
      disableBtn:false,
      popUpT:'Approve Customer',
      successMessage:false,
      action:"Approve",
      isEverythingOk:true,
    };
  },
  watch: {},
  computed: {
      activeUserInfo () { 
     
        return this.$store.state.auth.user
    },
    checkisLogin () {
    if(this.activeUserInfo && _.has(this.activeUserInfo ,"accessToken") && _.has(this.activeUserInfo ,'userId')){
        return true;
    }else{
        return false;
    }

    }
  },
  methods: {

  getTokenDetails() {
     this.isEverythingOk =false;
    let payload = {
      pin:this.key,
    }
     this.$vs.loading();
      this.$store
        .dispatch("getTokenDetails", payload)
        .then((res) => {
           this.$vs.loading.close();
          if(res.status){
             this.getDetails();
          }else{
            
          this.isEverythingOk =false;
          this.$vs.loading.close();
          this.error =true;
          this.msg = "Verification token is already used";


          }
         
        })
        .catch((err)=>{
         
           this.$vs.loading.close();

           this.isEverythingOk =false;
          this.$vs.loading.close();
          this.error =true;
          this.msg = err.error_message.message;


        })

  },

       setPreference(event, item) {
     if (item.selected) {
       if( this.selected_settings.indexOf(item._d) <=-1){
         this.selected_settings.push(item._id);
       }
     } else {
        if( this.selected_settings.indexOf(item._id) >=-1){
         this.selected_settings.splice(  this.selected_settings.indexOf(item._id) ,1 );
         _.forEach(this.settings_list ,(object ,index)=>{
           if(item._id == object._id){
             this.settings_list[index].selected = false;
           }
         })
       }

     }

     if(this.selected_settings.indexOf(1)<=-1 && this.selected_settings.indexOf(2) >-1){
       _.forEach(this.settings_list ,(ob ,index)=>{
          if(ob['_id'] ==2){
            ob['selected'] =false;


          }
       });
       this.selected_settings   = _.filter(this.selected_settings ,(obj)=>{
         return obj !=2;
       });
     }
    },
    getDetails(callFromEmit =false){
      //alert(callFromEmit)
      this.error =false;
      const payload = {
        userId: this.userId,
      };
      this.$vs.loading();
      this.$store
        .dispatch("getUserDetails", payload)
        .then((res) => {
          if (res.details) {
            this.selectedUser = res;
            this.isEverythingOk =true;
            this.getUserSettings();
             
          }else{
               this.isEverythingOk =false;
               this.error =true;
               this.msg = "Somthing went wrong!"
             this.$vs.loading.close();
          }
        
           
        })
        .catch((err) => {
          this.isEverythingOk =false;
          this.$vs.loading.close();
          this.error =true;
          this.msg = err.message;
        });

    },
    getUserSettings() {
    
    
     const postData = {
          email: this.selectedUser.details.email,
        };  
        this.$store
          .dispatch("get_recent_settings", postData)
          .then((response) => {
             this.$vs.loading.close();
            if (response) {
              this.selected_settings =[];
              _.forEach(response ,(obj)=>{
                this.selected_settings.push(obj._id);

                _.forEach(this.settings_list ,(object ,index)=>{
                    if(obj._id == object._id){
                      this.settings_list[index].selected = true;

                    }

                  })

              })
               this.popupApprove = true;
            }else{
              
             //  this.error =true;
             //  this.msg = "Somthing went wrong!"
            }
             this.isEverythingOk =true;
         
          
          })
          .catch((err) => {
            // this.isEverythingOk =false;
            //  this.$vs.loading.close();
            // this.error =true;
            // this.msg = err.message;
          });
    },
    
   onApprove() {
     
      let payload = {
        settings: this.selected_settings,
        userId: this.userId,
        "statusName":"Active",
        statusId: 2,
      };

//(selectedUser.isFirstCustomer && !selectedUser.companyDetails.name )
  if(_.has(this.selectedUser ,"isFirstCustomer") && this.selectedUser['isFirstCustomer']){
    payload['companyName'] =this.selectedUser.companyDetails.name;

  }
    if(this.action!="Approve"){
      payload['statusId'] =3
      payload["statusName"] ="Inactive";
      
    }

      this.disableBtn = true;
      this.successMessage =false;
      this.error =false;
      this.msg ='';
      this.$store
        .dispatch("auth/updateStatus", payload)
        .then((res) => {
          this.popupApprove = false;
          this.popupApprove =false;
          this.successMessage =true;
          this.isEverythingOk =false;
          this.msg =res.message;
          this.$vs.notify({
            title: "Success",
            text: res.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "success",
          });
          setTimeout(() => {
               this.disableBtn = false;
              this.$router.push(this.$router.currentRoute.query.to || '/')

          })

        })
        .catch((error) => {
           this.disableBtn = false;
           this.msg =error;
           this.errot =true;

          this.$vs.notify({
            title: "Error",
            text: error,
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
  mounted() {
      this.isEverythingOk =false;
    if(
        ( _.has(this.$route ,"query" ))
        && ( _.has(this.$route.query ,"userId" ) &&  this.$route.query.userId != undefined &&   this.$route.query.userId != null)
        && (  _.has(this.$route.query ,"key" ) &&  this.$route.query.key != undefined &&   this.$route.query.key != null)
         && (  _.has(this.$route.query ,"action" ) &&  this.$route.query.action != undefined &&   this.$route.query.action != null)

        ) {
        this.action = this.$route.query.action;
        this.userId = this.$route.query.userId;
        this.key = this.$route.query.key;
        this.validateEmail = false;
        this.error = false
       this.popupApprove =false;
      if(this.checkisLogin){
        if(this.activeUserInfo.loginRoleId ==1){

          //get settings
      this.$store.dispatch("getSettings").then((response) => {
        let dt = response;
        this.settings_list = dt;

      });
      
         this.getTokenDetails();
         

        }else{
           
            this.popupApprove =false;
          this.msg ="You do not have access to complete this action.";  
          this.error = true;
          setTimeout(() =>{
                    this.$router.push(this.$router.currentRoute.query.to || '/')

          },100)


        }
        
        
      }
      
         }else{
            this.msg ="You do not have access to complete this action.";  
            this.error = true;
            setTimeout(() =>{
                      this.$router.push(this.$router.currentRoute.query.to || '/')

            },100)
         }
   
  },
  created() {
    // if (!moduleUserManagement.isRegistered) {
    //   this.$store.registerModule("userManagement", moduleUserManagement);
    //   moduleUserManagement.isRegistered = true;
    // }
    // this.$store.dispatch("userManagement/fetchUsers").catch((err) => {
    //   console.error(err);
    // });
  },
};
</script>

<style lang="scss">
.login_wrap {
  padding-top: 10px;
  .vs-input {
    padding-top: 15px;
  }
}

.login-tabs-container {
  padding: 50px 0;
  .con-tab {
    padding-bottom: 14px;
  }
  .con-slot-tabs {
    margin-top: 1rem;
  }
  h4 {
    font-size: 24px;
    font-family: "NiveauGroteskBold";
    color: #062339;
    margin-bottom: 10px;
  }
  p {
    display: block;
    color: #062339;
    font-family: "NiveauGroteskRegular";
    font-size: 16px;
  }
}
</style>
